const CAP21 = {
  id: 21,
  slug: "cap21-definicion-blockchain",
  title: "Capítulo 21 — Definición de la tecnología Blockchain",
  sections: [
    {
      heading: "¿Qué es Blockchain?",
      text: [
        "La tecnología blockchain se popularizó con la llegada de la primera criptomoneda descentralizada. Desde entonces, su aplicación se ha expandido rápidamente a sectores como finanzas, salud, educación, logística, identidad digital y más.",
        "Blockchain es considerada una innovación disruptiva debido a su capacidad para ofrecer **seguridad, transparencia, inmutabilidad, trazabilidad y eficiencia** en la gestión de datos y transacciones.",
        "En esencia, la tecnología blockchain es un sistema de registro y almacenamiento de datos que permite crear un **libro mayor digital, descentralizado, distribuido y seguro**.",
        "Cada registro, llamado **bloque**, contiene información sobre transacciones o eventos digitales y está **criptográficamente enlazado** al bloque anterior, formando una cadena. De ahí el nombre *blockchain* (cadena de bloques).",
        "Gracias a esta estructura, **una vez que un bloque es añadido a la cadena, no puede ser alterado ni eliminado**, lo que garantiza la inmutabilidad."
      ]
    },
    {
      heading: "Características fundamentales de Blockchain",
      text: [
        "Una de las características más importantes de la tecnología blockchain es que funciona como un sistema de **contabilidad distribuida (DLT: Distributed Ledger Technology)**.",
        "A diferencia de los sistemas tradicionales, blockchain **no depende de un servidor central**, sino que distribuye los datos entre múltiples participantes llamados **nodos**.",
        "Cada nodo posee una copia completa y exacta del libro mayor, lo que permite que la verificación de los datos sea independiente, transparente y confiable."
      ],
      list: [
        "🔹 No depende de una autoridad central.",
        "🔹 Cada nodo tiene una copia del registro.",
        "🔹 Todos los participantes pueden verificar la información.",
        "🔹 Permite realizar transacciones directas entre usuarios (peer-to-peer)."
      ]
    },
    {
      heading: "Beneficios de la naturaleza distribuida",
      text: [
        "La distribución de la información en múltiples nodos permite:",
        "🛡️ **Seguridad**: no hay un solo punto de falla o ataque.",
        "📖 **Transparencia**: todos los participantes ven la misma información.",
        "🚫 **Eliminación de intermediarios**: se pueden realizar transacciones directas, con menores costos y mayor rapidez.",
        "🧾 **Trazabilidad**: es posible rastrear el origen y el historial de cualquier registro."
      ]
    },
    {
      heading: "Uso de criptografía",
      text: [
        "La tecnología blockchain utiliza técnicas criptográficas avanzadas para proteger los datos, garantizar la autenticidad de los registros y evitar manipulaciones.",
        "Cada bloque incluye un **hash criptográfico**, que actúa como huella digital única del contenido.",
        "Cualquier intento de modificar la información de un bloque produciría un nuevo hash, evidenciando el intento de manipulación."
      ]
    },
    {
      heading: "Ventajas y desventajas de Blockchain",
      text: [
        "Blockchain ofrece numerosas ventajas, pero también presenta ciertos desafíos que es importante conocer."
      ],
      list: [
        "**Ventajas:**",
        "🔹 Reducción de costos: elimina intermediarios.",
        "🔹 Mayor eficiencia: las transacciones se pueden validar más rápido.",
        "🔹 Seguridad e inmutabilidad: los registros no pueden ser manipulados.",
        "🔹 Transparencia: todos pueden verificar la información.",
        "🔹 Confianza sin intermediarios: los usuarios confían en el sistema, no en una entidad.",
        "",
        "**Desventajas:**",
        "⚠️ Escalabilidad limitada: puede volverse lenta si la red crece demasiado.",
        "⚠️ Consumo energético (en algunos modelos como PoW).",
        "⚠️ Complejidad técnica para usuarios y empresas.",
        "⚠️ Falta de estándares globales para la implementación.",
        "",
        "**Nota:** Muchos de estos desafíos están siendo gradualmente superados con nuevas tecnologías como Proof of Stake, blockchain de segunda capa, mejoras en eficiencia energética y soluciones híbridas."
      ]
    },
    {
      heading: "Resumen final",
      text: [
        "La tecnología blockchain está en **constante evolución** y sigue expandiéndose a múltiples industrias.",
        "Sus propiedades como **descentralización, transparencia, trazabilidad e inmutabilidad** la convierten en una herramienta poderosa para transformar procesos tradicionales.",
        "Comprender estos conceptos es el primer paso para aprovechar todo el potencial de blockchain en aplicaciones reales, seguras y confiables."
      ]
    }
  ]
};

export default CAP21;
